<ng-container *ngIf="isMobile;then mobile else web">

</ng-container>

<ng-template #web>
    <app-material>
        <div class="header" header>
            <h2>{{ 'lift-operator.incoming-tool-request.table-title' | translate }}</h2>
        </div>
        <ng-container body>
            <app-incoming-tools-table
                [tools]="requests"
                [tableConfig]="tableConfig"
                [title]="'lift-operator.incoming-tool-request.table-title' | translate"
                [isLoading]="isLoading"
                [requestType]="type"
                [section]="'REQUESTS'"
                [isMaterial]="false"
                [hasTitle]="false"
                [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                (sortChange)="onSortChange($event)"
                (filterChange)="onFilter($event)"
                (pageChange)="onPageChange($event)"
                (onProcessClick)="onProcess($event)"
                (onResumeProcess)="onResumeProcess($event)">
            </app-incoming-tools-table>
        </ng-container>
    </app-material>
</ng-template>

<ng-template #mobile>
    <app-material [material]="false">
        <div class="header" header>
            <h5>{{ title | translate }}
            </h5>
            <app-icon library="fontawesome" variant="fa-filter" (click)="openFilterSheet()"></app-icon>
        </div>
        <div class="body" body>
            <app-listbox [items]="toolProcessingEntries"
                         [selectable]="true"
                         [isMaterial]="false"
                         [isLoading]="isLoading"
                         template="lift">
                <ng-template let-record #custom>
                    <app-tool-processing-card [entry]="record" (select)="onSelect($event)">

                    </app-tool-processing-card>
                </ng-template>
            </app-listbox>
        </div>
        <div class="footer" footer>

        </div>
    </app-material>

    <app-tool-processing-filter-bottom-sheet
        [availableStatuses]="availableStatuses"
        [availableTypes]="availableTypes"
        [availableLines]="availableLines"
        [config]="tableConfig"
        (apply)="onApplyFilters($event)">
    </app-tool-processing-filter-bottom-sheet>

</ng-template>
